import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { CourseData } from './CourseData';
import TabPanel from '../../common/TabPanel';
import ActionHistoryDetails from '../ActionHistory/ActionHistoryDetails';

export default function CourseDetailsTabs({ id, termCode, crn }) {
  const tabs = ['Course Details', 'Action History'];
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <>
      <Box
        id={`${id}__tabs_box_wrapper`}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          id={`${id}__tabs`}
          className="myOdu__tabs"
          value={selectedTab}
          onChange={(event, value) => setSelectedTab(value)}
          aria-label={'Course Details Tabs'}
        >
          {tabs.map((sem, index) => (
            <Tab
              key={`${id}__tab_${index}`}
              label={sem}
              id={`${id}__tab_${index}`}
              aria-controls={`${id}__tabPanel_${index}`}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((_, index) => {
        return (
          <React.Fragment key={`${id}_${index}`}>
            {index === 0 && (
              <TabPanel
                key={`${id}__tabPanel_${index}`}
                value={selectedTab}
                index={index}
                id={`${id}__tabPanel_${index}`}
                className="myOdu__tabPanel pt-0 px-0"
                lablledby={`${id}__tab_${index}`}
              >
                <CourseData id={id} termCode={termCode} crn={crn} />
              </TabPanel>
            )}
            {index === 1 && (
              <TabPanel
                key={`${id}__tabPanel_${index}`}
                value={selectedTab}
                index={index}
                id={`${id}__tabPanel_${index}`}
                className="myOdu__tabPanel pt-0 px-0"
                lablledby={`${id}__tab_${index}`}
              >
                <ActionHistoryDetails id={id} crn={crn} termCode={termCode} />
              </TabPanel>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}
